/** Stored on a facet when the user picks “None”. */
export const FILTER_NONE_VALUE = null;

export const FILTER_NONE_LABEL = 'None';

/** Prefix on an option value that sends the field as `false`. The bare field sends `true`. */
export const BOOLEAN_EXCLUDE_PREFIX = 'exclude:';

export function isNoneFilterValue(
  value: readonly (string | number | null)[] | undefined
): boolean {
  return value?.length === 1 && value[0] === null;
}

/** Ids to load for an entity filter. `null` is the None choice and is not an id. */
export function entityFilterIds(
  value: readonly (string | number | null)[]
): (string | number)[] {
  return value.filter((item): item is string | number => item != null);
}

/** Map a boolean option token to its API field and `true` / `false` value. */
export function booleanFilterToken(token: string): {
  field: string;
  value: 'true' | 'false';
} {
  if (token.startsWith(BOOLEAN_EXCLUDE_PREFIX)) {
    return {
      field: token.slice(BOOLEAN_EXCLUDE_PREFIX.length),
      value: 'false',
    };
  }
  return { field: token, value: 'true' };
}

/** Include (`field`) and exclude (`exclude:field`) of the same field cannot both be selected. */
export function oppositeBooleanToken(token: string): string {
  if (token.startsWith(BOOLEAN_EXCLUDE_PREFIX)) {
    return token.slice(BOOLEAN_EXCLUDE_PREFIX.length);
  }
  return `${BOOLEAN_EXCLUDE_PREFIX}${token}`;
}
